import styled from 'styled-components';

export const Wrap = styled.div`
  position: relative;
  display: inline-flex;
`;

export const Trigger = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 30px;
  padding: 0 10px;
  cursor: pointer;
  font-family: inherit;
  font-size: 12px;
  font-weight: 600;
  border-radius: 999px;
  white-space: nowrap;
  color: ${(props) => (props.$onDark ? 'rgba(242, 246, 243, 0.85)' : 'var(--cp-text-secondary, #5b6770)')};
  background: ${(props) => (props.$onDark ? 'rgba(255, 255, 255, 0.08)' : 'var(--cp-surface-alt, #fafbfc)')};
  border: 1px solid ${(props) => (props.$onDark ? 'rgba(255, 255, 255, 0.12)' : 'var(--cp-border, #e5e7eb)')};
  transition: color 0.15s ease, border-color 0.15s ease, background 0.15s ease;

  &:hover {
    color: var(--cp-green, #47b972);
    border-color: var(--cp-green, #47b972);
  }

  svg {
    width: 15px;
    height: 15px;
    flex: none;
  }

  .caret {
    width: 9px;
    height: 9px;
    opacity: 0.6;
    transition: transform 0.18s ease;
  }
  &[aria-expanded='true'] .caret {
    transform: rotate(180deg);
  }
`;

export const Menu = styled.div`
  position: absolute;
  right: 0;
  ${(props) => (props.$dropUp ? 'bottom: calc(100% + 8px);' : 'top: calc(100% + 8px);')}
  min-width: 168px;
  padding: 6px;
  z-index: 60;
  border-radius: 12px;
  background: var(--cp-surface, #fff);
  border: 1px solid var(--cp-border, #e5e7eb);
  box-shadow: 0 12px 34px rgba(0, 0, 0, 0.18);
`;

export const Item = styled.button`
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 8px 10px;
  cursor: pointer;
  border: none;
  border-radius: 8px;
  font-family: inherit;
  font-size: 13px;
  text-align: left;
  color: var(--cp-text, #2a3134);
  background: ${(props) => (props.$active ? 'rgba(71, 185, 114, 0.12)' : 'transparent')};
  transition: background 0.12s ease, color 0.12s ease;

  &:hover {
    background: ${(props) => (props.$active ? 'rgba(71, 185, 114, 0.16)' : 'var(--cp-surface-hover, #f5f7f6)')};
  }

  .code {
    margin-left: auto;
    font-size: 11px;
    font-weight: 600;
    letter-spacing: 0.5px;
    color: ${(props) => (props.$active ? 'var(--cp-green, #47b972)' : 'var(--cp-text-tertiary, #859196)')};
  }

  .native {
    color: ${(props) => (props.$active ? 'var(--cp-green, #47b972)' : 'inherit')};
    font-weight: ${(props) => (props.$active ? 600 : 400)};
  }
`;
